import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {Favorite, FavoriteList} from '@models/favorite';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {TrackingService} from '@services/tracking.service';
import {AuthenticationService} from '@services/authentification.service';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
        list: new UntypedFormControl(''),
    });
    lists: FavoriteList[] = [];
    favorite: Favorite;
    user: User = Object.assign({}, EMPTY_USER);
    mode = ""
    loading = false;

    constructor(
        private adService: AdService,
        public dialogRef: MatDialogRef<AddComponent>,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.mode = this.data.mode;
        this.user = this.authenticationService.currentUser;
        this.adService.getFavoritesLists().subscribe(r => {
            this.lists = r;
            this.favoriteForm.get('list').setValue(r[0].id);
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true
            this.trackingService.addFavorite();
            if (this.favoriteForm.get('title').value) {
                const favoriteList: FavoriteList = {
                    title: this.favoriteForm.get('title').value,
                    user_id: 0,
                    favorites: [],
                    share: false,
                    owner_name: "",
                };
                this.adService.addFavoritesList(favoriteList).subscribe((listId) => {
                    if (this.mode == 'create') {
                        this.adService.createFavorites(this.favorite, listId).subscribe(r => {
                            this.manageResponse(r);
                        });
                    } else {
                        this.adService.moveFavorite(listId, this.favorite).subscribe(r => {
                            this.manageResponse(r);
                        });
                    }
                }, error => {
                    this.alertService.error('Une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                    console.log(error);
                    this.loading = false;
                });
            } else if (this.favoriteForm.get('list').value) {
                if (this.mode == 'create') {
                    this.adService.createFavorites(this.favorite, this.favoriteForm.get('list').value).subscribe(r => {
                        this.manageResponse(r);
                    });
                } else {
                    this.adService.moveFavorite(this.favoriteForm.get('list').value, this.favorite).subscribe(r => {
                        this.manageResponse(r);
                    });
                }
            } else {
                this.dialogRef.close(false);
            }
        }
    }

    manageResponse(r: Favorite) {
        if (r.title == "toomany") {
            this.dialogRef.close("toomany");
        } else {
            this.dialogRef.close([this.favoriteForm.get('list').value, r]);
        }
    }
}
